import React, {
    useEffect,
    useState
}
from "react";


import {
    functions
}
from "../../constants/common-functions";

import {
    useParams,
    useHistory
}
from "react-router-dom";

import "./eva.css";

import evaLogo from "./images/eva_logo.png";
import evaPerson from "./images/eva_person.png";

import useEva from "./hooks/useEva";

import EvaFooter
from "./components/EvaFooter";

import EvaDirectoryCard
from "./components/EvaDirectoryCard";

import {
    FontAwesomeIcon
}
from "@fortawesome/react-fontawesome";

import {
    faMagnifyingGlass,
    faFolder,
    faFile,
    faFilePdf,
    faFileWord,
    faFileExcel,
    faArrowRight,
    faArrowUpRightFromSquare,
    faPlay,
    faChevronRight
}
from "@fortawesome/free-solid-svg-icons";

import banner from "./images/banner.png";


export default function EvaDirectory()
{
	
	const history =
	    useHistory();
		
	//--------------------------------------------------------
	// Viewer
	//--------------------------------------------------------

	const [viewer, setViewer] =
	    useState(null);
		
	//--------------------------------------------------------
	// Document viewer
	//--------------------------------------------------------

	const [openDocument, setOpenDocument] =
	    useState(null);

	const [openDocumentUrl, setOpenDocumentUrl] =
	    useState(null);

    //--------------------------------------------------------
    // Route
    //--------------------------------------------------------

    const {
        directoryId
    } = useParams();


    //--------------------------------------------------------
    // EVA
    //--------------------------------------------------------

    const {
        directory,
        directoryChildren,
        directoryDocuments,
        directorySections,

        directoryLoading,
        childrenLoading,
        documentsLoading,
        sectionsLoading,

        loadDirectory

    } = useEva();
	
	
	//--------------------------------------------------------
	// Open directory
	//--------------------------------------------------------

	const openDirectory =
	    (item) =>
	    {
	        if (!item ||
	            !item.id)
	        {
	            return;
	        }


	        history.push(
	            "/evadirectory/"
	            + item.id
	        );
	    };
		
		
		//--------------------------------------------------------
		// Open section item
		//--------------------------------------------------------

		const openSectionItem =
		    (item) =>
		    {
		        if (!item ||
		            !item.url)
		        {
		            return;
		        }


		        //------------------------------------------------
		        // Embedded content
		        //------------------------------------------------

		        if (item.type === "EMBED")
		        {
		            setViewer({
		                title:
		                    item.title
		                    ||
		                    "Content",

		                url:
		                    item.url
		            });

		            return;
		        }


		        //------------------------------------------------
		        // External link
		        //------------------------------------------------

		        window.open(
		            item.url,
		            "_blank",
		            "noopener,noreferrer"
		        );
		    };


		//--------------------------------------------------------
		// Close viewer
		//--------------------------------------------------------

		const closeViewer =
		    () =>
		    {
		        setViewer(null);
		    };


			
			
			//--------------------------------------------------------
			// Open document
			//--------------------------------------------------------

			const openFile =
			    (document) =>
			    {
			        if (!document ||
			            !document.id)
			        {
			            return;
			        }


			        functions.getBlobFromAjax(

			            "/resolutionsoftwareplatform/api/sharepoint/file/"
			            + document.id,

			            function(blob)
			            {
			                const url =
			                    window.URL.createObjectURL(
			                        blob
			                    );


			                setViewer(
			                    {
			                        title:
			                            document.name
			                            ||
			                            "Document",

			                        url: url,

			                        blobUrl: true
			                    }
			                );
			            }
			        );
			    };
						
    //--------------------------------------------------------
    // Load directory
    //--------------------------------------------------------

    useEffect(
        () =>
        {
            if (directoryId)
            {
                loadDirectory(
                    directoryId
                );
            }
        },
        [directoryId]
    );


    //--------------------------------------------------------
    // Configured directories
    //--------------------------------------------------------

    const configuredDirectories =
        directoryChildren.filter(
            (item) =>
            {
                return item.configured;
            }
        );


    //--------------------------------------------------------
    // Standard directories
    //--------------------------------------------------------

    const standardDirectories =
        directoryChildren.filter(
            (item) =>
            {
                return !item.configured;
            }
        );


    //--------------------------------------------------------
    // Image
    //--------------------------------------------------------

    const getImageSource =
        (item) =>
        {
            if (!item ||
                !item.image)
            {
                return null;
            }


            return (
                "data:"
                + (
                    item.imageContentType
                    ||
                    "image/jpeg"
                )
                + ";base64,"
                + item.image
            );
        };


    //--------------------------------------------------------
    // Document icon
    //--------------------------------------------------------

    const getDocumentIcon =
        (document) =>
        {
            const extension =
                (
                    document.extension
                    ||
                    ""
                ).toLowerCase();


            if (extension === "pdf")
            {
                return faFilePdf;
            }


            if (
                extension === "doc"
                ||
                extension === "docx"
            )
            {
                return faFileWord;
            }


            if (
                extension === "xls"
                ||
                extension === "xlsx"
            )
            {
                return faFileExcel;
            }


            return faFile;
        };


    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    return (

        <div style={pageStyle}>


            {/* ------------------------------------------------
                Header
            ------------------------------------------------ */}

            <header
                style={headerStyle}
                className="eva-header"
            >

                <img
                    src={evaLogo}
                    alt="EVA"
                    style={logoStyle}
                />


                <div style={headerActionsStyle}>

                    <div style={searchStyle}>

                        <FontAwesomeIcon
                            icon={faMagnifyingGlass}
                            style={searchIconStyle}
                        />

                        <span>
                            Search
                        </span>

                    </div>


                    <div style={profileStyle}>
                        RB
                    </div>

                </div>

            </header>


            {/* ------------------------------------------------
                Directory hero
            ------------------------------------------------ */}

            <section style={heroStyle} className="eva-directory-hero">
				<div
				    style={{
				        position: "absolute",
				        top: 0,
				        right: 0,
				        width: "72%",
				        height: "100%",
				        backgroundImage:
				            "url(" + banner + ")",
				        backgroundSize: "cover",
				        backgroundPosition: "center right",
				        backgroundRepeat: "no-repeat",
				        opacity: 0.13,
				        pointerEvents: "none",
				        zIndex: 0
				    }}
				/>
	                <div style={heroImageContainerStyle} className="eva-directory-hero-image">
	
	                    {
	                        getImageSource(
	                            directory
	                        )
	                        ?
	                        <img
	                            src={
	                                getImageSource(
	                                    directory
	                                )
	                            }
	                            alt=""
	                            style={heroImageStyle}
	                            className="eva-directory-fade"
	                        />
	                        :
	                        <div
	                            style={heroImagePlaceholderStyle}
	                        >
	                            <FontAwesomeIcon
	                                icon={faFolder}
	                            />
	                        </div>
	                    }
	
	                </div>
	
	
	                <div
	                    style={heroTextStyle}
	                    className="eva-directory-hero-text eva-directory-fade"
	                >
	
	                    <div style={breadcrumbStyle}>
						<span
						        style={breadcrumbLinkStyle}
						        onClick={() =>
						        {
						            history.push(
						                "/eva"
						            );
						        }}
						    >
						        EVA
						    </span>
	                        <span style={breadcrumbDividerStyle}>
	                            /
	                        </span>
	                        {
								directory?.title
								||
								directory?.name
	                        }
	                    </div>
	
	
	                    <h1 style={heroTitleStyle}>
	
	                        {
	                            directoryLoading
	                            ?
	                            "Loading..."
	                            :
	                            (
	                                directory?.title
	                                ||
	                                directory?.name
	                                ||
	                                "Directory"
	                            )
	                        }
	
	                    </h1>
	
	
	                    {
	                        directory?.description
	                        &&
	                        <p style={heroDescriptionStyle}>
	                            {directory.description}
	                        </p>
	                    }
	
	                </div>
	
	
	                {/* EVA person */}
	
	                <img
	                    src={evaPerson}
	                    alt="EVA assistant"
	                    style={evaPersonStyle}
	                    className="eva-directory-eva"
	                />
				
            </section>


            {/* ------------------------------------------------
                Main content
            ------------------------------------------------ */}

            <main style={contentStyle} className="eva-directory-content">


                {/* ------------------------------------------------
                    Left column
                ------------------------------------------------ */}

                <div style={leftColumnStyle} className="eva-directory-left">


				{/* --------------------------------------------

				    Configured directories

				-------------------------------------------- */}

				{
				    (
				        childrenLoading
				        ||
				        configuredDirectories.length > 0
				    )
				    &&
				    <section style={contentSectionStyle}>

				        <div style={sectionHeaderStyle}>

				            <div>

				                <div style={sectionEyebrowStyle}>
				                    EXPLORE
				                </div>

				                <h2 style={sectionTitleStyle}>
				                    Browse this area
				                </h2>

				            </div>

				        </div>


				        <div style={directoryCardsStyle}  className="eva-directory-cards">

				            {
				                childrenLoading
				                ?
				                <>
				                    <div style={cardSkeletonStyle} />
				                    <div style={cardSkeletonStyle} />
				                </>
				                :
				                configuredDirectories.map(
				                    (item) =>
				                    {
				                        return (
				                            <EvaDirectoryCard
				                                key={item.id}
				                                item={item}
				                                clickFunction={
				                                    openDirectory
				                                }
				                            />
				                        );
				                    }
				                )
				            }

				        </div>

				    </section>
				}

                    {/* --------------------------------------------
                        Documents
                    -------------------------------------------- */}

                    <section style={contentSectionStyle}>

                        <div style={sectionHeaderStyle}>

                            <div>

                                <div style={sectionEyebrowStyle}>
                                    DOCUMENTS
                                </div>

                                <h2 style={sectionTitleStyle}>
                                    Files & information
                                </h2>

                            </div>

                        </div>


                        <div style={documentListStyle} className="eva-document-list">

                            {
                                documentsLoading
                                ?
                                <>
                                    <div style={documentSkeletonStyle} />
                                    <div style={documentSkeletonStyle} />
                                    <div style={documentSkeletonStyle} />
                                </>
                                :
                                directoryDocuments.length > 0
                                ?
                                directoryDocuments.map(
                                    (document) =>
                                    {
                                        return (

                                            <div
                                                key={document.id}
                                                style={documentRowStyle}
                                                className="eva-document-row"
												role="button"
												tabIndex={0}

												onClick={() =>
												{
												    openFile(
												        document
												    );
												}}

												onKeyDown={(event) =>
												{
												    if (event.key === "Enter" ||
												        event.key === " ")
												    {
												        event.preventDefault();

												        openFile(
												            document
												        );
												    }
												}}
                                            >

                                                <div
                                                    style={documentIconStyle}
                                                >

                                                    <FontAwesomeIcon
                                                        icon={
                                                            getDocumentIcon(
                                                                document
                                                            )
                                                        }
                                                    />

                                                </div>


                                                <div style={documentInfoStyle}>

                                                    <div
                                                        style={documentNameStyle}
                                                    >
                                                        {document.name}
                                                    </div>

                                                    {
                                                        document.extension
                                                        &&
                                                        <div
                                                            style={documentMetaStyle}
                                                        >
                                                            {
                                                                document.extension
                                                                    .toUpperCase()
                                                            }
                                                        </div>
                                                    }

                                                </div>


                                                <FontAwesomeIcon
                                                    icon={faArrowRight}
                                                    style={documentArrowStyle}
                                                />

                                            </div>

                                        );
                                    }
                                )
                                :
                                <div style={emptyStyle}>
                                    No documents in this area.
                                </div>
                            }

                        </div>

                    </section>


                    {/* --------------------------------------------
                        Standard directories
                    -------------------------------------------- */}

                    {
                        standardDirectories.length > 0
                        &&
                        <section style={contentSectionStyle}>

                            <div style={sectionEyebrowStyle}>
                                MORE
                            </div>

                            <h2 style={sectionTitleStyle}>
                                Additional folders
                            </h2>


                            <div style={folderListStyle}>

                                {
                                    standardDirectories.map(
                                        (item) =>
                                        {
                                            return (

                                                <div
                                                    key={item.id}
                                                    style={folderRowStyle}
                                                >

                                                    <FontAwesomeIcon
                                                        icon={faFolder}
                                                        style={folderIconStyle}
                                                    />

                                                    <span>
                                                        {
                                                            item.title
                                                            ||
                                                            item.name
                                                        }
                                                    </span>

                                                    <FontAwesomeIcon
                                                        icon={faChevronRight}
                                                        style={folderArrowStyle}
                                                    />

                                                </div>

                                            );
                                        }
                                    )
                                }

                            </div>

                        </section>
                    }

                </div>


                {/* ------------------------------------------------
                    Right column
                ------------------------------------------------ */}

                <aside style={rightColumnStyle} className="eva-directory-right">

                    {
                        sectionsLoading
                        ?
                        <>
                            <div style={panelSkeletonStyle} />
                            <div style={panelSkeletonStyle} />
                        </>
                        :
                        directorySections.map(
                            (section) =>
                            {
                                return (

                                    <div
                                        key={section.title}
                                        style={sidePanelStyle}
                                        className="eva-side-panel"
                                    >

                                        <div style={sidePanelTitleStyle}>
                                            {section.title}
                                        </div>


                                        <div style={sidePanelItemsStyle}>

                                            {
                                                section.items.map(
                                                    (item, index) =>
                                                    {
                                                        const embed =
                                                            item.type
                                                            ===
                                                            "EMBED";


                                                        return (

															<div
															    key={
															        item.title
															        + index
															    }
															    style={sideItemStyle}
															    className="eva-side-item"
															    role="button"
															    tabIndex={0}
															    onClick={() =>
															    {
															        openSectionItem(
															            item
															        );
															    }}
															    onKeyDown={(event) =>
															    {
															        if (event.key === "Enter" ||
															            event.key === " ")
															        {
															            event.preventDefault();

															            openSectionItem(
															                item
															            );
															        }
															    }}
															>

                                                                <div
                                                                    style={
                                                                        embed
                                                                        ?
                                                                        embedIconStyle
                                                                        :
                                                                        linkIconStyle
                                                                    }
                                                                >

                                                                    <FontAwesomeIcon
                                                                        icon={
                                                                            embed
                                                                            ?
                                                                            faPlay
                                                                            :
                                                                            faArrowUpRightFromSquare
                                                                        }
                                                                    />

                                                                </div>


                                                                <div
                                                                    style={sideItemContentStyle}
                                                                >

                                                                    <div
                                                                        style={sideItemTitleStyle}
                                                                    >
                                                                        {item.title}
                                                                    </div>

                                                                    <div
                                                                        style={sideItemTypeStyle}
                                                                    >
                                                                        {
                                                                            embed
                                                                            ?
                                                                            "View content"
                                                                            :
                                                                            "Open resource"
                                                                        }
                                                                    </div>

                                                                </div>


                                                                <FontAwesomeIcon
                                                                    icon={faChevronRight}
                                                                    style={sideItemArrowStyle}
                                                                />

                                                            </div>

                                                        );
                                                    }
                                                )
                                            }

                                        </div>

                                    </div>

                                );
                            }
                        )
                    }

                </aside>

            </main>
			
			
			{
			    viewer
			    &&
			    <div
			        style={viewerBackdropStyle}
					className="eva-viewer-backdrop"
			        onClick={
			            closeViewer
			        }
			    >

			        <div
			            style={viewerModalStyle}
			            role="dialog"
			            aria-modal="true"
			            aria-label={
			                viewer.title
			            }
			            onClick={(event) =>
			            {
			                event.stopPropagation();
			            }}
			        >

			            <div style={viewerHeaderStyle} className="eva-viewer-header">

			                <div style={viewerTitleStyle}>
			                    {viewer.title}
			                </div>


			                <div style={viewerActionsStyle}>

			                    <button
			                        type="button"
			                        style={viewerSecondaryButtonStyle}
			                        onClick={() =>
			                        {
			                            window.open(
			                                viewer.url,
			                                "_blank",
			                                "noopener,noreferrer"
			                            );
			                        }}
			                    >
			                        Open in new window
			                    </button>


			                    <button
			                        type="button"
			                        style={viewerCloseButtonStyle}
			                        onClick={
			                            closeViewer
			                        }
			                    >
			                        Close
			                    </button>

			                </div>

			            </div>


			            <iframe
						className="eva-viewer-frame"
			                src={viewer.url}
			                title={viewer.title}
			                style={viewerFrameStyle}
			            />

			        </div>

			    </div>
			}


            {/* ------------------------------------------------
                EVA footer
            ------------------------------------------------ */}

            <EvaFooter />

        </div>

    );

}


//============================================================
// Page
//============================================================

const pageStyle =
{
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,

    width: "100vw",
    height: "100vh",

    background:
        "linear-gradient(180deg, #ffffff 0%, #f8f7fb 52%, #f3f2f8 100%)",

    color: "#17213b",

    fontFamily:
        "'Inter', 'Segoe UI', Arial, sans-serif",

    overflowX: "hidden",
    overflowY: "auto",

    zIndex: 1000
};


//============================================================
// Header
//============================================================

const headerStyle =
{
    position: "absolute",

    top: 0,
    left: 0,
    right: 0,

    height: "92px",

    padding:
        "0 clamp(22px, 4vw, 64px)",

    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",

    boxSizing: "border-box",

    zIndex: 20
};


const logoStyle =
{
    width: "clamp(190px, 18vw, 290px)",
    height: "auto",
    objectFit: "contain"
};


const headerActionsStyle =
{
    display: "flex",
    alignItems: "center",
    gap: "16px"
};


const searchStyle =
{
    height: "42px",
    minWidth: "160px",

    padding: "0 20px",

    display: "flex",
    alignItems: "center",
    gap: "10px",

    border:
        "1px solid rgba(94,67,180,0.15)",

    borderRadius: "24px",

    background:
        "rgba(255,255,255,0.78)",

    backdropFilter: "blur(12px)",

    color: "#6d6d82",

    fontSize: "14px"
};


const searchIconStyle =
{
    fontSize: "13px",
    color: "#6844c7"
};


const profileStyle =
{
    width: "42px",
    height: "42px",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    borderRadius: "50%",

    background:
        "linear-gradient(135deg, #17151d 0%, #2b2733 55%, #17151d 100%)",

    color: "#ffffff",

    fontSize: "13px",
    fontWeight: 700,

    boxShadow:
        "0 5px 14px rgba(20,16,30,0.18)"
};


//============================================================
// Hero
//============================================================

const heroStyle =
{
    position: "relative",

    minHeight: "320px",

    padding:
        "115px clamp(22px, 4vw, 64px) 34px",

    display: "flex",
    alignItems: "center",

    boxSizing: "border-box",

    overflow: "hidden",

    borderBottom:
        "1px solid rgba(103,77,170,0.08)"
};


const heroImageContainerStyle =
{
    width: "220px",
    height: "150px",

    flexShrink: 0,

    overflow: "hidden",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    borderRadius: "18px",

    background:
        "linear-gradient(135deg,#eeeaf8,#faf9fd)",

    boxShadow:
        "0 16px 38px rgba(54,40,90,0.10)"
};


const heroImageStyle =
{
    width: "100%",
    height: "100%",

    objectFit: "cover"
};


const heroImagePlaceholderStyle =
{
    fontSize: "46px",
    color: "#7655c8"
};


const heroTextStyle =
{
    position: "relative",

    maxWidth: "650px",

    marginLeft: "34px",

    zIndex: 4
};


const breadcrumbStyle =
{
    marginBottom: "12px",

    color: "#7253c4",

    fontSize: "12px",
    fontWeight: 700,

    letterSpacing: "1.2px",

    textTransform: "uppercase"
};


const breadcrumbDividerStyle =
{
    margin: "0 9px",

    color: "#b2a6ce"
};


const heroTitleStyle =
{
    margin: 0,

    fontSize:
        "clamp(36px, 3.4vw, 56px)",

    lineHeight: 1.05,

    fontWeight: 400,

    letterSpacing: "-1.5px",

    color: "#17213b"
};


const heroDescriptionStyle =
{
    maxWidth: "650px",

    margin: "15px 0 0 0",

    fontSize:
        "clamp(14px, 1.1vw, 17px)",

    lineHeight: 1.65,

    color: "#62687b"
};


const evaPersonStyle =
{
    position: "absolute",

    right: "8%",
    bottom: "-60px",

    height: "285px",

    objectFit: "contain",

    opacity: 0.96,

    zIndex: 2
};


//============================================================
// Content
//============================================================

const contentStyle =
{
    position: "relative",

    width: "100%",

    padding:
        "38px clamp(22px, 4vw, 64px) 60px",

    display: "grid",

    gridTemplateColumns:
        "minmax(0, 1fr) minmax(280px, 340px)",

    gap: "38px",

    boxSizing: "border-box",

    zIndex: 5
};


const leftColumnStyle =
{
    minWidth: 0
};


const rightColumnStyle =
{
    display: "flex",
    flexDirection: "column",

    gap: "20px"
};


const contentSectionStyle =
{
    marginBottom: "42px"
};


const sectionHeaderStyle =
{
    marginBottom: "18px",

    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between"
};


const sectionEyebrowStyle =
{
    marginBottom: "5px",

    fontSize: "10px",
    fontWeight: 800,

    letterSpacing: "1.6px",

    color: "#7957ca"
};


const sectionTitleStyle =
{
    margin: 0,

    fontSize: "22px",
    fontWeight: 600,

    color: "#252b40"
};


//============================================================
// Directory cards
//============================================================

const directoryCardsStyle =
{
    display: "grid",

    gridTemplateColumns:
        "repeat(2, minmax(0, 1fr))",

    gap: "16px"
};


const directoryCardStyle =
{
    position: "relative",

    minHeight: "112px",

    padding: "12px 42px 12px 12px",

    display: "flex",
    alignItems: "center",

    border:
        "1px solid rgba(75,58,120,0.08)",

    borderRadius: "14px",

    background:
        "rgba(255,255,255,0.88)",

    boxShadow:
        "0 10px 26px rgba(55,42,90,0.05)",

    cursor: "pointer",

    overflow: "hidden"
};


const directoryCardImageStyle =
{
    width: "118px",
    height: "88px",

    flexShrink: 0,

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    overflow: "hidden",

    borderRadius: "10px",

    background:
        "#f1eef8"
};


const cardImageStyle =
{
    width: "100%",
    height: "100%",

    objectFit: "cover"
};


const cardFolderIconStyle =
{
    fontSize: "30px",

    color: "#7655c8"
};


const directoryCardContentStyle =
{
    minWidth: 0,

    padding: "4px 14px"
};


const directoryCardTitleStyle =
{
    marginBottom: "6px",

    fontSize: "15px",
    fontWeight: 700,

    color: "#272c3f"
};


const directoryCardDescriptionStyle =
{
    display: "-webkit-box",

    overflow: "hidden",

    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",

    fontSize: "12.5px",

    lineHeight: 1.5,

    color: "#73778a"
};


const cardArrowStyle =
{
    position: "absolute",

    right: "18px",

    color: "#8a72c6",

    fontSize: "12px"
};


//============================================================
// Documents
//============================================================

const documentListStyle =
{
    border:
        "1px solid rgba(75,58,120,0.07)",

    borderRadius: "14px",

    overflow: "hidden",

    background:
        "rgba(255,255,255,0.72)"
};


const documentRowStyle =
{
    minHeight: "64px",

    padding: "0 18px",

    display: "flex",
    alignItems: "center",

    borderBottom:
        "1px solid rgba(75,58,120,0.06)",

    cursor: "pointer"
};


const documentIconStyle =
{
    width: "38px",
    height: "38px",

    flexShrink: 0,

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    borderRadius: "9px",

    background:
        "#f0edf8",

    color: "#7655c8",

    fontSize: "16px"
};


const documentInfoStyle =
{
    minWidth: 0,

    flex: 1,

    marginLeft: "13px"
};


const documentNameStyle =
{
    overflow: "hidden",

    textOverflow: "ellipsis",
    whiteSpace: "nowrap",

    fontSize: "13.5px",
    fontWeight: 600,

    color: "#34384b"
};


const documentMetaStyle =
{
    marginTop: "3px",

    fontSize: "9px",
    fontWeight: 700,

    letterSpacing: "0.8px",

    color: "#9a9cad"
};


const documentArrowStyle =
{
    marginLeft: "12px",

    color: "#9c8abc",

    fontSize: "11px"
};


//============================================================
// Standard folders
//============================================================

const folderListStyle =
{
    display: "flex",
    flexDirection: "column",

    gap: "8px",

    marginTop: "15px"
};


const folderRowStyle =
{
    minHeight: "50px",

    padding: "0 16px",

    display: "flex",
    alignItems: "center",

    border:
        "1px solid rgba(75,58,120,0.07)",

    borderRadius: "10px",

    background:
        "rgba(255,255,255,0.72)",

    color: "#44485a",

    fontSize: "13px",
    fontWeight: 600,

    cursor: "pointer"
};


const folderIconStyle =
{
    marginRight: "12px",

    color: "#7c61c5"
};


const folderArrowStyle =
{
    marginLeft: "auto",

    color: "#a397bd",

    fontSize: "11px"
};


//============================================================
// Right panels
//============================================================

const sidePanelStyle =
{
    overflow: "hidden",

    border:
        "1px solid rgba(83,62,133,0.08)",

    borderRadius: "15px",

    background:
        "rgba(255,255,255,0.88)",

    boxShadow:
        "0 12px 30px rgba(56,42,90,0.055)"
};


const sidePanelTitleStyle =
{
    padding: "17px 18px 13px",

    borderBottom:
        "1px solid rgba(83,62,133,0.06)",

    fontSize: "14px",
    fontWeight: 700,

    color: "#312b45"
};


const sidePanelItemsStyle =
{
    padding: "7px"
};


const sideItemStyle =
{
    minHeight: "58px",

    padding: "8px 9px",

    display: "flex",
    alignItems: "center",

    borderRadius: "10px",

    cursor: "pointer"
};


const linkIconStyle =
{
    width: "34px",
    height: "34px",

    flexShrink: 0,

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    borderRadius: "9px",

    background:
        "#f0edf8",

    color: "#7655c8",

    fontSize: "12px"
};


const embedIconStyle =
{
    ...linkIconStyle,

    background:
        "linear-gradient(135deg,#7550d5,#5c36b8)",

    color: "#ffffff"
};


const sideItemContentStyle =
{
    minWidth: 0,

    flex: 1,

    marginLeft: "11px"
};


const sideItemTitleStyle =
{
    overflow: "hidden",

    textOverflow: "ellipsis",
    whiteSpace: "nowrap",

    fontSize: "12.5px",
    fontWeight: 650,

    color: "#3b3d50"
};


const sideItemTypeStyle =
{
    marginTop: "3px",

    fontSize: "10px",

    color: "#9293a2"
};


const sideItemArrowStyle =
{
    marginLeft: "8px",

    color: "#a89bbc",

    fontSize: "10px"
};


//============================================================
// Loading / empty
//============================================================

const cardSkeletonStyle =
{
    height: "112px",

    borderRadius: "14px",

    background:
        "linear-gradient(90deg,#efedf4,#f8f7fa,#efedf4)"
};


const documentSkeletonStyle =
{
    height: "64px",

    borderBottom:
        "1px solid rgba(75,58,120,0.05)",

    background:
        "linear-gradient(90deg,#f1eff5,#faf9fb,#f1eff5)"
};


const panelSkeletonStyle =
{
    height: "160px",

    borderRadius: "15px",

    background:
        "linear-gradient(90deg,#efedf4,#faf9fb,#efedf4)"
};


const emptyStyle =
{
    padding: "22px",

    color: "#9697a5",

    fontSize: "13px"
};

const breadcrumbLinkStyle =
{
    cursor: "pointer",

    transition:
        "opacity 180ms ease"
};


//============================================================
// Viewer
//============================================================

const viewerBackdropStyle =
{
    position: "fixed",

    top: 0,
    left: 0,
    right: 0,
    bottom: 0,

    padding: "32px",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    background:
        "rgba(17, 15, 25, 0.58)",

    zIndex: 5000
};


const viewerModalStyle =
{
    width: "min(1200px, 94vw)",
    height: "min(820px, 90vh)",

    display: "flex",
    flexDirection: "column",

    overflow: "hidden",

    borderRadius: "16px",

    background: "#ffffff",

    boxShadow:
        "0 28px 80px rgba(15,10,30,0.30)"
};


const viewerHeaderStyle =
{
    minHeight: "68px",

    padding: "0 20px",

    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",

    gap: "20px",

    borderBottom:
        "1px solid rgba(75,58,120,0.08)"
};


const viewerTitleStyle =
{
    overflow: "hidden",

    textOverflow: "ellipsis",
    whiteSpace: "nowrap",

    fontSize: "15px",
    fontWeight: 700,

    color: "#252b40"
};


const viewerActionsStyle =
{
    display: "flex",

    alignItems: "center",

    gap: "10px"
};


const viewerSecondaryButtonStyle =
{
    padding: "9px 14px",

    border:
        "1px solid rgba(104,68,199,0.18)",

    borderRadius: "8px",

    background: "#ffffff",

    color: "#6844c7",

    fontSize: "12px",
    fontWeight: 600,

    cursor: "pointer"
};


const viewerCloseButtonStyle =
{
    padding: "9px 16px",

    border: 0,

    borderRadius: "8px",

    background: "#6844c7",

    color: "#ffffff",

    fontSize: "12px",
    fontWeight: 600,

    cursor: "pointer"
};


const viewerFrameStyle =
{
    width: "100%",

    flex: 1,

    border: 0,

    background: "#f5f5f7"
};